import { Injectable, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorNotificationService } from '../services/error-notification.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private router: Router, private errorSvc: ErrorNotificationService) { }

  handleError(error: any): void {
    //Update the error message 
    this.errorSvc.notify("We are having trouble completing your request.  Please contact the Public Document Room using the link in the Help & Info Menu.");
    
    //Display Custom Error Page
   this.showGlobalError();
  }

  showGlobalError() {
    this.router.navigate(['/error']);
  }
}
